import  { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-beige-light pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <h2 className="font-serif text-xl mb-4">LUSTRE & CO.</h2>
            <p className="text-sm mb-4">Exquisite, handcrafted jewelry created with passion and precision since 2005.</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-600 hover:text-gold">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gold">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-600 hover:text-gold">
                <Mail size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-serif text-lg mb-4">Shop</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/shop?category=rings" className="hover:text-gold">Rings</Link></li>
              <li><Link to="/shop?category=necklaces" className="hover:text-gold">Necklaces</Link></li>
              <li><Link to="/shop?category=bracelets" className="hover:text-gold">Bracelets</Link></li>
              <li><Link to="/shop?category=earrings" className="hover:text-gold">Earrings</Link></li>
              <li><Link to="/shop" className="hover:text-gold">New Arrivals</Link></li>
              <li><Link to="/shop" className="hover:text-gold">Best Sellers</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-serif text-lg mb-4">Information</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
              <li><Link to="/custom-jewelry" className="hover:text-gold">Custom Jewelry</Link></li>
              <li><Link to="/lookbook" className="hover:text-gold">Lookbook</Link></li>
              <li><Link to="#" className="hover:text-gold">Care Guide</Link></li>
              <li><Link to="#" className="hover:text-gold">Shipping & Returns</Link></li>
              <li><Link to="#" className="hover:text-gold">Privacy Policy</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-serif text-lg mb-4">Contact</h3>
            <address className="not-italic text-sm space-y-2">
              <p>500 Fifth Avenue</p>
              <p>New York, NY 10110</p>
              <p>United States</p>
              <p className="mt-4">hello@lustreandco.com</p>
              <p>+1 (212) 555-0198</p>
            </address>
          </div>
        </div>
        
        <div className="border-t border-beige-dark mt-12 pt-8 text-center text-sm text-gray-600">
          <p>© {new Date().getFullYear()} Lustre & Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
 